import { useRef, useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl'
import { GooglePlace } from 'src/utils/google-places'
import {
  RETAIL_PIN_LIGHT,
  RETAIL_PIN_DARK,
  OFFICE_PIN_LIGHT,
  OFFICE_PIN_DARK,
  INDUSTRIAL_PIN_LIGHT,
  INDUSTRIAL_PIN_DARK,
  MULTIFAMILY_PIN_LIGHT,
  MULTIFAMILY_PIN_DARK,
  SINGLEFAMILY_PIN_LIGHT,
  SINGLEFAMILY_PIN_DARK,
  OTHER_PIN_LIGHT,
  OTHER_PIN_DARK,
  SHOPPING_CENTER_PIN_LIGHT,
  SHOPPING_CENTER_PIN_DARK,
  BIG_BLUE_PIN_NAME,
  BLUE_DOT_NAME,
  BLUE_PIN_WITH_BB_NAME,
  BOTTOM_PIN_NAME,
  GREEN_PIN_BASIC_NAME,
  GREEN_PIN_NAME,
  GREEN_PIN_SELECTED_NAME,
  MIDDLE_PIN_NAME,
  PINK_DOT_NAME,
  PINK_PIN_NAME,
  TOP_PIN_NAME,
  SELECTED_PIN_NAME,
  GREEN_DOT_NAME,
  BLUE_PIN,
  POI_LAYER_ID,
  POI_HOVERED_LAYER_ID,
  POI_DOT_LAYER_ID,
  MEDICAL_PIN_LIGHT,
  MEDICAL_PIN_DARK,
  HOSPITALITY_PIN_LIGHT,
  HOSPITALITY_PIN_DARK,
  USER_LIST_LOCATION_LAYER_ID,
  RETAIL_SELECTED_PIN_DARK,
  RETAIL_SELECTED_PIN_LIGHT,
  OFFICE_SELECTED_PIN_DARK,
  OFFICE_SELECTED_PIN_LIGHT,
  MEDICAL_SELECTED_PIN_DARK,
  MEDICAL_SELECTED_PIN_LIGHT,
  INDUSTRIAL_SELECTED_PIN_DARK,
  INDUSTRIAL_SELECTED_PIN_LIGHT,
  HOSPITALITY_SELECTED_PIN_DARK,
  HOSPITALITY_SELECTED_PIN_LIGHT,
  MULTIFAMILY_SELECTED_PIN_DARK,
  MULTIFAMILY_SELECTED_PIN_LIGHT,
  SINGLEFAMILY_SELECTED_PIN_DARK,
  SINGLEFAMILY_SELECTED_PIN_LIGHT,
  OTHER_PIN_SELECTED_DARK,
  OTHER_PIN_SELECTED_LIGHT,
  SHOPPING_CENTER_SELECTED_PIN_DARK,
  SHOPPING_CENTER_SELECTED_PIN_LIGHT,
  RETAIL_PIN_ALT_LIGHT,
  RETAIL_PIN_ALT_DARK,
  OFFICE_PIN_ALT_LIGHT,
  OFFICE_PIN_ALT_DARK,
  MEDICAL_PIN_ALT_LIGHT,
  MEDICAL_PIN_ALT_DARK,
  INDUSTRIAL_PIN_ALT_LIGHT,
  INDUSTRIAL_PIN_ALT_DARK,
  SINGLEFAMILY_PIN_ALT_LIGHT,
  SINGLEFAMILY_PIN_ALT_DARK,
  MULTIFAMILY_PIN_ALT_LIGHT,
  MULTIFAMILY_PIN_ALT_DARK,
  OTHER_PIN_ALT_LIGHT,
  OTHER_PIN_ALT_DARK,
  HOSPITALITY_PIN_ALT_LIGHT,
  HOSPITALITY_PIN_ALT_DARK,
  MOBILITY_PIN_0,
  MOBILITY_PIN_1,
  MOBILITY_PIN_2,
  MOBILITY_PIN_3,
  MOBILITY_PIN_4,
  MOBILITY_PIN_5,
  MOBILITY_PIN_6,
  MOBILITY_PIN_7,
  RED_DOT_PIN,
  PIN_BASE_NAME,
} from 'src/constants/mapbox'

type Options = {
  onSourceAdded?: (id: string) => void
  onLayerAdded?: (id: string) => void
}

function loadImg(
  map: mapboxgl.Map,
  path: string,
  name: string,
  options: {
    pixelRatio?: number | undefined
    sdf?: boolean | undefined
    stretchX?: Array<[number, number]> | undefined
    stretchY?: Array<[number, number]> | undefined
    content?: [number, number, number, number] | undefined
  } = {}
) {
  if (map.listImages().find((image) => image === name)) {
    return
  }
  map.loadImage(path, (err, img) => {
    if (err) {
      throw err
    }

    if (!img) {
      console.warn('could not get image')
      return
    }

    if (name === PINK_PIN_NAME || name == BLUE_PIN_WITH_BB_NAME || name === GREEN_PIN_NAME) {
      options.stretchX = [
        [6, 7],
        [29, 30],
      ]
      options.stretchY = [[4, 16]]
      options.content = [6, 4, 30, 18]
    }

    if (name === GREEN_PIN_SELECTED_NAME || name === BIG_BLUE_PIN_NAME) {
      options.stretchX = [
        [16, 17],
        [55, 56],
      ]
      options.stretchY = [[8, 32]]
      options.content = [16, 8, 56, 32]
    }

    map.addImage(name, img, options)
  })
}

export function loadImages(map: mapboxgl.Map) {
  loadImg(map, `/category-pins/${RETAIL_PIN_LIGHT}.png`, RETAIL_PIN_LIGHT)
  loadImg(map, `/category-pins/${RETAIL_PIN_DARK}.png`, RETAIL_PIN_DARK)
  loadImg(map, `/category-pins/${RETAIL_PIN_ALT_LIGHT}.png`, RETAIL_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${RETAIL_PIN_ALT_DARK}.png`, RETAIL_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${RETAIL_SELECTED_PIN_DARK}.png`, RETAIL_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${RETAIL_SELECTED_PIN_LIGHT}.png`, RETAIL_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${OFFICE_PIN_LIGHT}.png`, OFFICE_PIN_LIGHT)
  loadImg(map, `/category-pins/${OFFICE_PIN_DARK}.png`, OFFICE_PIN_DARK)
  loadImg(map, `/category-pins/${OFFICE_PIN_ALT_LIGHT}.png`, OFFICE_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${OFFICE_PIN_ALT_DARK}.png`, OFFICE_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${OFFICE_SELECTED_PIN_DARK}.png`, OFFICE_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${OFFICE_SELECTED_PIN_LIGHT}.png`, OFFICE_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${MEDICAL_PIN_LIGHT}.png`, MEDICAL_PIN_LIGHT)
  loadImg(map, `/category-pins/${MEDICAL_PIN_DARK}.png`, MEDICAL_PIN_DARK)
  loadImg(map, `/category-pins/${MEDICAL_PIN_ALT_LIGHT}.png`, MEDICAL_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${MEDICAL_PIN_ALT_DARK}.png`, MEDICAL_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${MEDICAL_SELECTED_PIN_DARK}.png`, MEDICAL_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${MEDICAL_SELECTED_PIN_LIGHT}.png`, MEDICAL_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${INDUSTRIAL_PIN_LIGHT}.png`, INDUSTRIAL_PIN_LIGHT)
  loadImg(map, `/category-pins/${INDUSTRIAL_PIN_DARK}.png`, INDUSTRIAL_PIN_DARK)
  loadImg(map, `/category-pins/${INDUSTRIAL_PIN_ALT_LIGHT}.png`, INDUSTRIAL_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${INDUSTRIAL_PIN_ALT_DARK}.png`, INDUSTRIAL_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${INDUSTRIAL_SELECTED_PIN_DARK}.png`, INDUSTRIAL_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${INDUSTRIAL_SELECTED_PIN_LIGHT}.png`, INDUSTRIAL_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${HOSPITALITY_PIN_LIGHT}.png`, HOSPITALITY_PIN_LIGHT)
  loadImg(map, `/category-pins/${HOSPITALITY_PIN_DARK}.png`, HOSPITALITY_PIN_DARK)
  loadImg(map, `/category-pins/${HOSPITALITY_PIN_ALT_LIGHT}.png`, HOSPITALITY_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${HOSPITALITY_PIN_ALT_DARK}.png`, HOSPITALITY_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${HOSPITALITY_SELECTED_PIN_DARK}.png`, HOSPITALITY_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${HOSPITALITY_SELECTED_PIN_LIGHT}.png`, HOSPITALITY_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${MULTIFAMILY_PIN_LIGHT}.png`, MULTIFAMILY_PIN_LIGHT)
  loadImg(map, `/category-pins/${MULTIFAMILY_PIN_DARK}.png`, MULTIFAMILY_PIN_DARK)
  loadImg(map, `/category-pins/${MULTIFAMILY_PIN_ALT_LIGHT}.png`, MULTIFAMILY_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${MULTIFAMILY_PIN_ALT_DARK}.png`, MULTIFAMILY_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${MULTIFAMILY_SELECTED_PIN_DARK}.png`, MULTIFAMILY_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${MULTIFAMILY_SELECTED_PIN_LIGHT}.png`, MULTIFAMILY_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${SINGLEFAMILY_PIN_LIGHT}.png`, SINGLEFAMILY_PIN_LIGHT)
  loadImg(map, `/category-pins/${SINGLEFAMILY_PIN_DARK}.png`, SINGLEFAMILY_PIN_DARK)
  loadImg(map, `/category-pins/${SINGLEFAMILY_PIN_ALT_LIGHT}.png`, SINGLEFAMILY_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${SINGLEFAMILY_PIN_ALT_DARK}.png`, SINGLEFAMILY_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${SINGLEFAMILY_SELECTED_PIN_DARK}.png`, SINGLEFAMILY_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${SINGLEFAMILY_SELECTED_PIN_LIGHT}.png`, SINGLEFAMILY_SELECTED_PIN_LIGHT)

  loadImg(map, `/category-pins/${OTHER_PIN_LIGHT}.png`, OTHER_PIN_LIGHT)
  loadImg(map, `/category-pins/${OTHER_PIN_DARK}.png`, OTHER_PIN_DARK)
  loadImg(map, `/category-pins/${OTHER_PIN_ALT_LIGHT}.png`, OTHER_PIN_ALT_LIGHT)
  loadImg(map, `/category-pins/${OTHER_PIN_ALT_DARK}.png`, OTHER_PIN_ALT_DARK)
  loadImg(map, `/category-pins/${OTHER_PIN_SELECTED_DARK}.png`, OTHER_PIN_SELECTED_DARK)
  loadImg(map, `/category-pins/${OTHER_PIN_SELECTED_LIGHT}.png`, OTHER_PIN_SELECTED_LIGHT)

  loadImg(map, `/category-pins/${SHOPPING_CENTER_PIN_LIGHT}.png`, SHOPPING_CENTER_PIN_LIGHT)
  loadImg(map, `/category-pins/${SHOPPING_CENTER_PIN_DARK}.png`, SHOPPING_CENTER_PIN_DARK)
  loadImg(map, `/category-pins/${SHOPPING_CENTER_SELECTED_PIN_DARK}.png`, SHOPPING_CENTER_SELECTED_PIN_DARK)
  loadImg(map, `/category-pins/${SHOPPING_CENTER_SELECTED_PIN_LIGHT}.png`, SHOPPING_CENTER_SELECTED_PIN_LIGHT)

  loadImg(map, `/mobility-pins/${MOBILITY_PIN_0}.png`, MOBILITY_PIN_0)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_1}.png`, MOBILITY_PIN_1)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_2}.png`, MOBILITY_PIN_2)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_3}.png`, MOBILITY_PIN_3)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_4}.png`, MOBILITY_PIN_4)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_5}.png`, MOBILITY_PIN_5)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_6}.png`, MOBILITY_PIN_6)
  loadImg(map, `/mobility-pins/${MOBILITY_PIN_7}.png`, MOBILITY_PIN_7)

  loadImg(map, '/pink-dot.png', PINK_DOT_NAME)
  loadImg(map, '/blue-dot.png', BLUE_DOT_NAME)
  loadImg(map, '/green-dot.png', GREEN_DOT_NAME)
  loadImg(map, '/pink-pin-with-billboard.png', PINK_PIN_NAME)
  loadImg(map, '/green-pin-selected.png', GREEN_PIN_SELECTED_NAME)
  loadImg(map, '/blue-pin-big.png', BIG_BLUE_PIN_NAME)
  loadImg(map, '/blue-pin-with-billboard.png', BLUE_PIN_WITH_BB_NAME)
  loadImg(map, '/green-pin-with-billboard.png', GREEN_PIN_NAME)
  loadImg(map, '/green-pin-basic.png', GREEN_PIN_BASIC_NAME)
  loadImg(map, '/selected-pin.png', SELECTED_PIN_NAME)
  loadImg(map, '/top-pin.png', TOP_PIN_NAME)
  loadImg(map, '/middle-pin.png', MIDDLE_PIN_NAME)
  loadImg(map, '/bottom-pin.png', BOTTOM_PIN_NAME)
  loadImg(map, '/blue-pin.png', BLUE_PIN)
  loadImg(map, '/red-dot.png', RED_DOT_PIN)

  loadImg(map, '/pin-base.png', PIN_BASE_NAME, { sdf: true })
}

export function useMapboxHelper(map: mapboxgl.Map, options?: Options) {
  const sources = useRef<{ id: string; obj: mapboxgl.AnySourceData }[]>([])
  const layers = useRef<mapboxgl.AnyLayer[]>([])
  const styleRef = useRef(map.getStyle().name)
  const [currentStyle, setCurrenStyle] = useState(styleRef.current)

  map.on('styledata', () => {
    const newStyleName = map.getStyle().name
    if (newStyleName !== styleRef.current) {
      styleRef.current = newStyleName
      setCurrenStyle(newStyleName)
    }
  })

  map.on('style.load', () => {})

  useEffect(
    () => () => {
      // When redirecting to another page map is already removed
      if ((map as any)._removed) {
        return
      }
      layers.current.forEach((x) => map.removeLayer(x.id))
      sources.current.forEach((x) => map.removeSource(x.id))
    },
    []
  )

  useEffect(() => {
    if (layers.current.length === 0 || sources.current.length === 0 || !map) {
      return
    }

    sources.current.forEach((x) => {
      map.addSource(x.id, x.obj)
      options?.onSourceAdded?.(x.id)
    })
    layers.current.forEach((x) => {
      map.addLayer(x as any)
      options?.onLayerAdded?.(x.id)
    })
  }, [currentStyle, map])

  return {
    useSource: (id: string, source: mapboxgl.AnySourceData) => {
      useEffect(() => {
        const existingSource = map.getSource(id)
        if (!existingSource) {
          map.addSource(id, source)
          options?.onSourceAdded?.(id)
          sources.current.push({ id, obj: source })
        }
      }, [])
    },
    useLayer(layer: mapboxgl.AnyLayer) {
      useEffect(() => {
        const existingLayer = map.getLayer(layer.id)
        if (!existingLayer) {
          map.addLayer(layer)
          options?.onLayerAdded?.(layer.id)
          layers.current.push(layer)
        }
      }, [])
    },
    replaceSource: (id: string, source: mapboxgl.AnySourceData) => {
      const existingSource = map.getSource(id)
      if (existingSource) {
        const removedLayers: mapboxgl.AnyLayer[] = []
        layers.current.forEach((layer) => {
          if ((layer as any).source === id) {
            map.removeLayer(layer.id)
            removedLayers.push(layer)
          }
        })
        map.removeSource(id)
        map.addSource(id, source)
        sources.current = sources.current.map((x) => (x.id === id ? { id, obj: source } : x))
        removedLayers.forEach((layer) => map.addLayer(layer))
        map.triggerRepaint()
      }
    },
    setSourceData: (id: string, data: any) => {
      const source: any = map.getSource(id)
      if (!source) {
        return
      }
      source.setData(data)
      const index = sources.current.findIndex((x) => x.id === id)
      if (index === -1) {
        console.warn('Could not find source ', id)
        return
      }
      sources.current[index].obj = { ...sources.current[index].obj, data } as any
    },
  }
}

export function getFeatureCollectionForPlaces(places: (GooglePlace & { brand?: string })[]) {
  return {
    type: 'FeatureCollection',
    features: places.map((place) => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [place.geometry.location[0], place.geometry.location[1]],
      },
      properties: {
        brand: place.brand || place.name,
      },
    })),
  }
}

export function getFeatureCollectionForHoveredPlace(feature: mapboxgl.MapboxGeoJSONFeature) {
  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: feature.geometry,
        properties: feature.properties,
      },
    ],
  }
}

export function isPOILayerClicked(map: mapboxgl.Map, point: mapboxgl.Point) {
  const poiFeatures = map.queryRenderedFeatures(point, {
    layers: [POI_LAYER_ID, POI_HOVERED_LAYER_ID, POI_DOT_LAYER_ID, USER_LIST_LOCATION_LAYER_ID],
  })

  return poiFeatures.length > 0
}
